
@switch (data.type) {
  @case (questionTypes.MATCHING_QUESTION) {
    <lib-question-matching
      [animation]="!slideHidden() ? data.animation : animations.NONE"
      [animationDelay]="animationDelay"
      [items]="data.items"
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()">
    </lib-question-matching>
  }
  @case (questionTypes.ORDER_QUESTION) {
    <app-question-ordering
      [animation]="!slideHidden() ? data.animation : animations.NONE"
      [animationDelay]="animationDelay"
      [answers]="data.items.questions"
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()">
    </app-question-ordering>
  }
  @case (questionTypes.QUESTION_SLIDER) {
    <app-question-slider
      [data]="data"
      [questionHash]="data.questionHash"
      [animation]="!slideHidden() ? data.animation : animations.NONE"
      [animationDelay]="animationDelay"
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()">
    </app-question-slider>
  }
  @case (questionTypes.QUESTION_SCALE) {
    <app-question-scale
      [data]="data"
      [questionHash]="data.questionHash"
      [animation]="!slideHidden() ? data.animation : animations.NONE"
      [animationDelay]="animationDelay"
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()">
    </app-question-scale>
  }
  @case (questionTypes.BOOLEAN_QUESTION) {
    <app-question-boolean
      [animation]="!slideHidden() ? data.animation : animations.NONE"
      [animationDelay]="animationDelay"
      [questionHash]="data.questionHash"
      [isTwoColumn]="isHorizontal"
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()">
    </app-question-boolean>
  }
  @case (questionTypes.FILL_BLANKS) {
    <app-question-fill-blank
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()"
      [animation]="!slideHidden() ? data.animation : animations.NONE"
      [animationDelay]="animationDelay"
      [text]="data.text"
      [questionHash]="data.questionHash"
      [type]="data.fillStyle"
      [availableValues]="data.availableValues"
      [blankWidth]="data.blankWidth">
    </app-question-fill-blank>
  }
  @case (questionTypes.QUESTION_ASSIGNMENT) {
    <app-manual-assessment-question-widget
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()"
      [question]="data"
      >
    </app-manual-assessment-question-widget>
  }
  @case (questionTypes.QUESTION_FREE_TEXT) {
    <app-question-free-text
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()"
      [questionHash]="data.questionHash"
      [question]="isSlideBuilder && data.question">
    </app-question-free-text>
  }
  @case (questionTypes.QUESTION_PRONUNCIATION) {
    <app-pronunciation-question
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()"
      [text]="data.text"
      [id]="data.id"
      [questionHash]="data.questionHash">
    </app-pronunciation-question>
  }
  @case (questionTypes.QUESTION_HOTSPOTS) {
    <app-question-hotspot
      [data]="data"
      [questionHash]="data.questionHash"
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()">
    </app-question-hotspot>
  }
  @default {
    <app-question-select
      [answers]="data.answers"
      [mediaType]="data.mediaType"
      [mediaRatio]="data.mediaRatio"
      [animation]="!slideHidden() ? data.animation : animations.NONE"
      [animationDelay]="animationDelay"
      [isTwoColumn]="isHorizontal"
      [(ngModel)]="answer"
      (ngModelChange)="setAnswer()"
      [multichoice]="data.multichoice && !isBranchingSlide?.()">
    </app-question-select>
  }
  @case (slidesTypes.SlideSorting) {
    <lib-question-sorting-widget 
      [animation]="!slideHidden() ? data.animation : animations.NONE"
      [animationDelay]="animationDelay"
      [items]="data.items"
      [buckets]="data.buckets"
      [orienation]="data.orientation"
      [answer]="answer"
      (answerChange)="setAnswer($event)">
    </lib-question-sorting-widget>
  }

  @case (slidesTypes.SlideBuilder) {
    <app-slide-builder
      [slideData]="data"
      [chapterContainerHeight]="chapterContainerHeight"
      [requiredToWatchVideo]="requiredToWatchVideo"
      [requiredToCompleteInteraction]="requiredToCompleteInteraction"
      (videoWatched)="emitVideoWatched($event)"
      (answerChanged)="slideAnswerChanged($event)"
      (interactionCompleted)="slideInteractionCompleted($event)">
    </app-slide-builder>
  }
}
